let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aDWmt")).then(() => parcelRequire('2vAnn'));